import React, { useEffect, useState } from 'react';
import { FileInput } from 'lucide-react';
import { salesService } from '../services';

const gbp = (v) => `\u00A3${Number(v || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Read-only: Sales-module records pinned to this session (e.g. PSB historical import).
export const SessionLinkedSalesBanner = ({ sessionId }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!sessionId) return;
    salesService.list({ session_id: sessionId, limit: 100 })
      .then((res) => setItems(res?.items || []))
      .catch(() => setItems([]));
  }, [sessionId]);

  if (!items.length) return null;
  const posted = items.filter((s) => s.status === 'posted');
  return (
    <div className="mb-4 rounded-md border border-sky-300 bg-sky-50 p-3 text-xs text-sky-900" data-testid="session-linked-sales-banner">
      <p className="font-medium flex items-center gap-1.5">
        <FileInput className="h-4 w-4" /> Sales recorded outside this grid ({items.length} record{items.length > 1 ? 's' : ''})
      </p>
      <p className="mt-1">
        These are used by the calculation when Posted, in addition to any quantities entered below.
        Posted total: <strong data-testid="session-linked-sales-posted-total">{gbp(posted.reduce((a, s) => a + (s.lines_total || 0), 0))}</strong>
      </p>
      <ul className="mt-1 space-y-0.5">
        {items.map((s) => (
          <li key={s.id} data-testid={`session-linked-sale-${s.id}`}>
            {s.reference_number || `Sale #${s.id}`} · {s.source_type === 'psb_import' ? 'PSB import' : s.source_type} · {s.sales_date} · {s.status} · {gbp(s.lines_total)}
          </li>
        ))}
      </ul>
    </div>
  );
};
